import { z } from "zod";
// NOTE: enum-derived types are written as explicit string unions, NOT
// `z.infer<typeof …Schema>`. Under zod 4 the emitted `.d.ts` keeps `z.infer` of
// `z.ZodEnum<{…}>` deferred, and consumer packages re-resolve it against zod's
// v3/v4 type surface — yielding a broken array-like type. A concrete union
// emits a resolved type the consumer can't misread. Keep each union in lockstep
// with its schema's members (guarded below).
export const SubscriptionTierSchema = z.enum(["free", "pro"]);
export const SubscriptionStatusSchema = z.enum(["active", "past_due", "canceled", "expired"]);
// Default values derived from Zod schemas for type safety
export const DEFAULT_SUBSCRIPTION_TIER = "free";
export const DEFAULT_SUBSCRIPTION_STATUS = "active";
export const DEFAULT_REFRESH_TOKEN_EXPIRY_MS = 90 * 24 * 60 * 60 * 1000; // 90 days
export const ConnectorLimitTypeSchema = z.enum(["total", "per-provider"]);
export const ConnectorLimitConfigSchema = z.object({
    type: ConnectorLimitTypeSchema,
    count: z.number(), // -1 for unlimited
});
export const SubscriptionLimitsSchema = z.object({
    connectors: ConnectorLimitConfigSchema,
    apiCallsPerDay: z.number(),
    accessLevel: z.enum(["readonly", "readwrite"]),
    features: z.array(z.string()),
});
const _tierParity = true;
const _statusParity = true;
const _connectorLimitParity = true;
void _tierParity;
void _statusParity;
void _connectorLimitParity;
export const SUBSCRIPTION_LIMITS = {
    free: {
        connectors: { type: "total", count: 1 },
        apiCallsPerDay: -1, // unlimited
        accessLevel: "readwrite",
        features: ["basic_read", "full_write", "task_completion"],
    },
    pro: {
        connectors: { type: "total", count: -1 }, // All connectors
        apiCallsPerDay: -1, // unlimited
        accessLevel: "readwrite",
        features: ["basic_read", "full_write", "task_completion", "cross_provider_sync"],
    },
};
//# sourceMappingURL=subscription.js.map